var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-valentines_day",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "sectionTitleImage",
              fn: function () {
                return [
                  _c(
                    "h2",
                    { staticClass: "menu--section-title-valentines_day" },
                    [
                      _c("img", {
                        staticClass: "menu--section_logo",
                        attrs: {
                          src: "/library/images/menu/header-valentines-2026.png",
                          alt: "Valentine's Day",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "menu--section_background" }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2527688963
        ),
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-valentines_day",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
        },
        scopedSlots: _vm._u([
          {
            key: "sectionTitleImage",
            fn: function () {
              return [
                _c(
                  "h2",
                  { staticClass: "menu--section-title-valentines_day" },
                  [
                    _c("img", {
                      staticClass: "menu--section_logo",
                      attrs: {
                        src: "/library/images/menu/header-valentines-2026.png",
                        alt: "Valentine's Day",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "menu--section_background" }),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }